import { render, staticRenderFns } from "./delivery-address.vue?vue&type=template&id=1f41aa74&"
import script from "./delivery-address.vue?vue&type=script&lang=js&"
export * from "./delivery-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports